import { ChangeDetectionStrategy, Component, computed, EventEmitter, input, Output } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import { PActionButtonModule } from '@panaya/ui/p-action-button';
import { PIconModule } from '@panaya/ui/p-icon';
import { AttachmentSource } from '../model/attachment-source.model';

interface SourceMenuItem {
    source: AttachmentSource;
    dividerBefore: boolean;
}

/** The prompt bar's "+" button and the menu of the attachment sources the agent allows this turn. */
@Component({
    standalone: true,
    selector: 'p-ai-chat-attachment-sources-menu',
    imports: [MatMenuModule, MatDividerModule, TranslateModule, PActionButtonModule, PIconModule],
    templateUrl: './attachment-sources-menu.component.html',
    styleUrl: './attachment-sources-menu.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AttachmentSourcesMenuComponent {
    protected readonly items = computed(() => toMenuItems(this.sources()));

    // TODO(Angular 17.3+): replace the EventEmitter output with output()
    @Output() public readonly sourceSelected = new EventEmitter<AttachmentSource>();

    /** The items, in menu order; a divider separates two consecutive items of different groups. */
    public readonly sources = input.required<AttachmentSource[]>();
    public readonly disabled = input(false);
}

function toMenuItems(sources: AttachmentSource[]): SourceMenuItem[] {
    return sources.map((source, index) => ({ source, dividerBefore: index > 0 && sources[index - 1].group !== source.group }));
}
